import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { AiOutlineArrowLeft, AiOutlineArrowRight } from "react-icons/ai";
import { FaStar } from "react-icons/fa";
import axios from "../../Utilities/axios";
import chevronDeluxe from "../../assets/hotel_rooms/chevron_deluxe4.jpg";
import chevronExecutive from "../../assets/hotel_rooms/chevron_executive2.jpg";
import guzapePlus from "../../assets/hotel_rooms/guzape_executive_plus.jpg";
import enuguDeluxe from "../../assets/hotel_rooms/enugu_executive_deluxe2.jpg";
import ogidiDeluxe from "../../assets/hotel_rooms/ogidi_executive_deluxe1.jpg";
import ajaoSuite from "../../assets/hotel_rooms/ajao_suite2.jpg";
import lekkiSuite from "../../assets/Lekki_phase1_hotel_images/Suite/lekki_phase1_suite7.JPEG";
import { HOTEL_RATINGS } from "../../Utilities/googlePlaces";
import ImageWithFallback from "../common/ImageWithFallback";
import "./HotelRoom.css";

const defaultRooms = [
  {
    name: "Residency Deluxe",
    price: "52,500",
    image: chevronDeluxe,
    hotelId: "5",
    hotelName: "Residency Hotel Lekki Osapa London Lagos",
    apiRoomName: "Residency Deluxe",
    desc: "King-sized bed, high-speed Wi-Fi, flat-screen TV, full air conditioning, mini fridge, wardrobe, walk-in shower, tiled floors, scenic views.",
  },
  {
    name: "Residency Executive Suite",
    price: "52,500",
    image: chevronExecutive,
    hotelId: "5",
    hotelName: "Residency Hotel Lekki Osapa London Lagos",
    apiRoomName: "Residency Executive Suite",
    desc: "Atlantic Ocean view, tastefully decorated king-sized bed, separate lounge, separate walk-in shower. Located in the heart of Lekki.",
  },
  {
    name: "Executive Luxury",
    price: "57,000",
    image: guzapePlus,
    hotelId: "2",
    hotelName: "Residency Hotel Guzape Abuja",
    apiRoomName: "Residency Executive Luxury",
    desc: "City view, spacious layout, full air conditioning, king-sized bed, flat-screen TV, wardrobe, mini fridge, walk-in shower.",
  },
  {
    name: "Standard Room",
    price: "47,500",
    image: enuguDeluxe,
    hotelId: "4",
    hotelName: "Residency Hotel Independence Layout Enugu",
    apiRoomName: "Residency Deluxe",
    desc: "Luxurious king-sized bed, high-speed Wi-Fi, flat-screen TV, full air conditioning, mini fridge, wardrobe, walk-in shower, stunning views.",
  },
  {
    name: "Executive Standard",
    price: "45,000",
    image: ogidiDeluxe,
    hotelId: "1",
    hotelName: "Residency Hotel Ogidi Anambra",
    apiRoomName: "Executive Deluxe",
    desc: "6x6 king-sized bed, air conditioning, flat-screen TV, bedside drawers, walk-in shower.",
  },
  {
    name: "Residency Deluxe Plus",
    price: "60,000",
    image: ajaoSuite,
    hotelId: "7",
    hotelName: "Residency Hotel Ajao Estate Lagos",
    apiRoomName: "Residency Suite Plus",
    desc: "King-sized bed, high-speed Wi-Fi, flat-screen TV, full air conditioning, mini fridge, wardrobe, walk-in shower, tiled floors, scenic views.",
  },
  {
    name: "Mini Suite",
    price: "75,000",
    image: lekkiSuite,
    hotelId: "NMcOxFCq1krkU6o",
    hotelName: "Residency Hotel Lekki Phase 1",
    apiRoomName: "Residency Executive Deluxe",
    desc: "Tastefully decorated king-sized bed, separate lounge, large bathroom with walk-in shower.",
  },
  {
    name: "Residency Executive Plus",
    price: "57,000",
    image: guzapePlus,
    hotelId: "2",
    hotelName: "Residency Hotel Guzape Abuja",
    apiRoomName: "Residency Executive Plus",
    desc: "Separate living and sleeping areas, apartment-like experience, ideal for extended stays, utmost luxury and space.",
  },
];

const HotelRooms = () => {
  const navigate = useNavigate();
  const [lightboxIndex, setLightboxIndex] = useState(null);
  const [rooms, setRooms] = useState(defaultRooms);
  const [hotelsData, setHotelsData] = useState({});
  const [carouselIndex, setCarouselIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(true);
  const carouselIndexRef = useRef(0);
  const isMovingRef = useRef(false);
  const total = rooms.length;

  const moveCarousel = (direction) => {
    if (isMovingRef.current || total === 0) return;

    isMovingRef.current = true;
    const currentIndex = carouselIndexRef.current;

    if (direction === "next") {
      const nextIndex = currentIndex + 1;
      carouselIndexRef.current = nextIndex;
      setCarouselIndex(nextIndex);

      window.setTimeout(() => {
        if (nextIndex === total) {
          setIsTransitioning(false);
          carouselIndexRef.current = 0;
          setCarouselIndex(0);
          window.requestAnimationFrame(() => setIsTransitioning(true));
        }
        isMovingRef.current = false;
      }, 700);
      return;
    }

    if (currentIndex === 0) {
      setIsTransitioning(false);
      carouselIndexRef.current = total;
      setCarouselIndex(total);
      window.requestAnimationFrame(() => {
        setIsTransitioning(true);
        carouselIndexRef.current = total - 1;
        setCarouselIndex(total - 1);
      });
    } else {
      const previousIndex = currentIndex - 1;
      carouselIndexRef.current = previousIndex;
      setCarouselIndex(previousIndex);
    }

    window.setTimeout(() => {
      isMovingRef.current = false;
    }, 700);
  };

  useEffect(() => {
    const interval = window.setInterval(() => moveCarousel("next"), 4800);
    return () => window.clearInterval(interval);
  }, [total]);

  const generateRandomCode = (length) => {
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let code = "";
    for (let i = 0; i < length; i++) {
      code += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return code;
  };

  useEffect(() => {
    const fetchHotelData = async () => {
      try {
        const today = new Date();
        const tomorrow = new Date(today);
        tomorrow.setDate(tomorrow.getDate() + 1);
        const startDate = today.toISOString().split("T")[0];
        const endDate = tomorrow.toISOString().split("T")[0];

        const hotelIds = [...new Set(defaultRooms.map((r) => r.hotelId))];
        const roomMap = {};
        const hotelsMap = {};

        await Promise.all(
          hotelIds.map(async (hotelId) => {
            try {
              const res = await axios.get(
                `/hotels/${hotelId}/roomAvailabilitySummary?startDate=${startDate} ${startDate} 15:00:00&endDate=${endDate} ${endDate} 13:00:00&sourceType=showInCompanySite`,
              );
              res.data.forEach((room) => {
                const key = `${hotelId}_${room.roomTypeName}`;
                roomMap[key] = room;
              });
              if (res.data.length > 0) {
                hotelsMap[hotelId] = res.data[0];
              }
            } catch (err) {
              console.error(`Failed to fetch rooms for hotel ${hotelId}:`, err);
            }
          }),
        );

        setHotelsData(hotelsMap);

        const updatedRooms = defaultRooms.map((room) => {
          const hotelRoom = roomMap[`${room.hotelId}_${room.apiRoomName}`];
          if (hotelRoom) {
            return {
              ...room,
              price: hotelRoom.roomCost.toLocaleString(),
              desc: hotelRoom.shortDescription || room.desc,
            };
          }
          return room;
        });
        setRooms(updatedRooms);
      } catch (err) {
        console.error("Failed to fetch hotel data:", err);
      }
    };
    fetchHotelData();
  }, []);

  const handleBookNow = (room) => {
    const randomCode = generateRandomCode(20);
    const hotel = hotelsData[room.hotelId] || {
      hotelId: room.hotelId,
      hotelName: room.hotelName,
    };
    const hotelSlug = room.hotelName.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");
    navigate(`/hotel-rooms/${hotelSlug}/${room.hotelId}/${randomCode}`, {
      state: { hotel },
    });
  };

  const findHotelRating = (hotelName) => {
    const name = (hotelName || "").toLowerCase().trim();
    for (const [key, value] of Object.entries(HOTEL_RATINGS)) {
      if (key.toLowerCase().trim() === name) {
        return value;
      }
    }
    for (const [key, value] of Object.entries(HOTEL_RATINGS)) {
      const keyLower = key.toLowerCase();
      const keyWords = keyLower.split(" ").filter(w => w.length > 3);
      const matchCount = keyWords.filter(w => name.includes(w)).length;
      if (matchCount >= 2) {
        return value;
      }
    }
    return null;
  };

  return (
    <section className="hr-section">
      <div className="hr-header">
        <span className="hr-header__label">Accommodation</span>
        <h2 className="hr-header__title">Residency Rooms</h2>
        <p className="hr-header__subtitle">
          Our Rooms are specially designed for your luxury and comfort,
          furnished with modern, state-of-the art amenities. Your satisfaction
          is guaranteed.
        </p>
      </div>

      <div className="hr-carousel" aria-label="Available rooms">
        <button
          className="hr-carousel__control hr-carousel__control--prev"
          onClick={() => moveCarousel("prev")}
          aria-label="Show previous rooms"
        >
          <AiOutlineArrowLeft />
        </button>

        <div
          className={`hr-track ${isTransitioning ? "" : "hr-track--resetting"}`}
          style={{ "--carousel-index": carouselIndex }}
        >
          {[...rooms, ...rooms].map((room, i) => {
            const roomIndex = i % total;

            return (
              <article
                key={`${room.name}-${i}`}
                className="hr-card"
                onClick={() => setLightboxIndex(roomIndex)}
                role="button"
                tabIndex={0}
                aria-label={`View ${room.name} full image`}
              >
                <div className="hr-card__image">
                  <ImageWithFallback src={room.image} hotelName={room.hotelName} alt={room.name} />
                </div>
                <div className="hr-card__content">
                  {/* <span className="hr-slide__price">&#8358;{room.price}</span>
                  <span className="hr-slide__pernight"> / per night</span> */}
                  <h3 className="hr-slide__name">{room.name}</h3>
                  <p className="hr-slide__hotel">{room.hotelName}</p>
                  {/* {findHotelRating(room.hotelName) && findHotelRating(room.hotelName).rating && (
                    <div className="hr-card__rating">
                      {[1, 2, 3, 4, 5].map((star) => (
                        <FaStar
                          key={star}
                          className={star <= Math.round(findHotelRating(room.hotelName).rating) ? 'star-filled' : 'star-empty'}
                        />
                      ))}
                      <span className="hr-card__rating-score">
                        {findHotelRating(room.hotelName).rating}
                      </span>
                    </div>
                  )} */}
                  <button
                    className="hr-slide__btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleBookNow(room);
                    }}
                  >
                    Book Now
                  </button>
                </div>
              </article>
            );
          })}
        </div>

        <button
          className="hr-carousel__control hr-carousel__control--next"
          onClick={() => moveCarousel("next")}
          aria-label="Show next rooms"
        >
          <AiOutlineArrowRight />
        </button>
      </div>

      {/* Lightbox */}
      {lightboxIndex !== null && (
        <div className="hr-lightbox" onClick={() => setLightboxIndex(null)}>
          <button
            className="hr-lightbox__close"
            onClick={() => setLightboxIndex(null)}
            aria-label="Close"
          >
            ✕
          </button>
          <ImageWithFallback
            src={rooms[lightboxIndex].image}
            hotelName={rooms[lightboxIndex].hotelName}
            alt={rooms[lightboxIndex].name}
            className="hr-lightbox__img"
          />
          <div className="hr-lightbox__footer">
            <button
              onClick={(e) => {
                e.stopPropagation();
                setLightboxIndex((lightboxIndex - 1 + total) % total);
              }}
              aria-label="Previous"
            >
              <AiOutlineArrowLeft />
            </button>
            <span>{rooms[lightboxIndex].name}</span>
            <button
              onClick={(e) => {
                e.stopPropagation();
                setLightboxIndex((lightboxIndex + 1) % total);
              }}
              aria-label="Next"
            >
              <AiOutlineArrowRight />
            </button>
          </div>
        </div>
      )}
    </section>
  );
};

export default HotelRooms;
